import type { TFunction } from 'i18next'
import type { OperationResult } from '@/shared/api/operationResult'

export type AttendanceAction =
  | 'syncEmployee'
  | 'archiveEmployee'
  | 'uploadPhoto'
  | 'saveDevice'
  | 'deleteDevice'
  | 'openDoor'
  | 'writeWebhook'

/**
 * Davomat servisi natija matnini faqat o'zbekcha yozadi. Boshqa tilda
 * panel o'z tarjimasini ko'rsatadi; texnik `detail` o'zgarmaydi.
 */
export function localizeOutcome(
  result: OperationResult,
  action: AttendanceAction,
  t: TFunction,
): OperationResult {
  if (t('common.langCode') === 'uz') return result
  const key = `attendance.outcome.${action}.${result.status}`
  const message = t(key, { defaultValue: '' }) || t(`attendance.outcome.any.${result.status}`)
  return { ...result, message }
}
